import { DecimalPipe } from '@angular/common';
import { Directive, ElementRef, HostListener, Output, EventEmitter, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
@Directive({
    selector: '[percentageDebounce]',
    standalone: false
})
export class TwoDigitDecimalPercentageDirective implements OnInit {
  @Output()
  public percentageDebounce = new EventEmitter<any>();
  private subject: Subject<Number> = new Subject();

  constructor(private el: ElementRef,
    public decimalPipe: DecimalPipe) {
  }
  @HostListener('keyup', ['$event'])
  onKeyUp(event) {
    var num = event.target.value.replace(/[$,]/g, "");
    if(num == "") {
      num = 0;
    }
    const valuesAsFloat = parseFloat(num);
    num = parseFloat(this.decimalPipe.transform(valuesAsFloat, '1.2-2').replace(/,/g, ''));
    this.subject.next(num);
  }

  ngOnInit() {
    this.subject.pipe(debounceTime(600)).subscribe(searchTextValue => {
      if(Number.isNaN(searchTextValue)){
        searchTextValue = 0;
      }
      this.el.nativeElement.value = searchTextValue.toFixed(2) + '%';
      console.log('im here debounce',searchTextValue);
      this.percentageDebounce.emit(searchTextValue);
    });
  }
}
